import React from "react";
import Icon from "../../../../../../common/components/Icon/Icon";
import TableCell from "../../../../TableList/TableCell/TableCell";
import TableContainer from "../../../../TableList/TableContainer";
import TableRow from "../../../../TableList/TableRow/TableRow";
import TableSection from "../../../../TableList/TableSection/TableSection";
import LModal from "../../../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../../../common/components/Modals/ModalHeader/ModalHeader";

// styles
import styles from "./ChubbLifeMultiBenefitDiscountModel.module.scss";

interface IChubbLifeMultiBenefitDiscountProps {
    isOpen: boolean;
    onClose: () => void;
}

const ChubbLifeMultiBenefitDiscountModal: React.FC<IChubbLifeMultiBenefitDiscountProps> = (
    props
) => {
    const { isOpen, onClose } = props;

    return (
        <LModal
            Header={() => (
                <ModalHeader
                    onClose={onClose}
                    title="Chubb Life Multi-benefit discount"
                />
            )}
            calcHeightMode="auto"
            width="wide"
            isOpen={isOpen}
            onClose={onClose}>
            {() => (
                <div>
                    <p>
                        To support New Zealanders looking to take out new cover,
                        we&apos;re pleased to offer a multi-benefit discount on our
                        comprehensive Assurance Extra product range.
                    </p>
                    <TableContainer footnote="Please note Specific Injury Cover, Premium Cover and Redundancy Cover do not count as qualifying covers under the Optional Benefit Groups, so will not activate or increase the discount. However, the premiums for these benefits will be discounted as part of the overall discount offer.">
                        <TableSection>
                            <TableRow>
                                <TableCell isHeader size="large">
                                    Number of Benefit Groups
                                </TableCell>
                                <TableCell isHeader size="medium">
                                    Discount Offered
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell size="large">
                                    LIFE + 1 Optional Benefit Group
                                </TableCell>
                                <TableCell>10%</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell size="large">
                                    LIFE + 2 Optional Benefit Groups
                                </TableCell>
                                <TableCell>12.5%</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell size="large">
                                    LIFE + 3 or more Optional Benefit Groups
                                </TableCell>
                                <TableCell>15%</TableCell>
                            </TableRow>
                        </TableSection>
                    </TableContainer>

                    <h3>Benefit Groups</h3>
                    <p>
                        To qualify benefits have a minimum cover amount, as outlined in
                        the table below.
                    </p>

                    <TableContainer>
                        <TableSection>
                            {/* Title */}
                            <TableRow>
                                <TableCell isHeader size="large">
                                    Is Mandatory
                                </TableCell>
                                <TableCell isHeader size="large">
                                    Benefit Group
                                </TableCell>
                                <TableCell isHeader size="large">
                                    Minimum Sum Insured
                                </TableCell>
                                <TableCell isHeader size="large">
                                    Qualifying covers under the Benefit Group
                                </TableCell>
                            </TableRow>
                            {/* Life */}
                            <TableRow>
                                <TableCell size="large" alignContent="center">
                                    <Icon
                                        id="GreenTick"
                                        className={styles["icon-size"]} />
                                </TableCell>
                                <TableCell size="large">LIFE</TableCell>
                                <TableCell size="large">$200,000&nbsp;*</TableCell>
                                <TableCell size="large">
                                    <ul>
                                        <li>Life Cover</li>
                                        <li>Life Income Cover *</li>
                                    </ul>
                                </TableCell>
                            </TableRow>
                            {/* Trauma */}
                            <TableRow>
                                <TableCell size="large" alignContent="center">
                                    <Icon
                                        id="SliderMinus"
                                        className={styles["icon-size"]}
                                    />
                                </TableCell>
                                <TableCell size="large">TRAUMA</TableCell>
                                <TableCell size="large">$75,000</TableCell>
                                <TableCell size="large">
                                    <ul>
                                        <li>Trauma Cover – accelerated</li>
                                        <li>Trauma Cover - standalone</li>
                                    </ul>
                                </TableCell>
                            </TableRow>
                            {/* Complete Disability */}
                            <TableRow>
                                <TableCell size="large" alignContent="center">
                                    <Icon
                                        id="SliderMinus"
                                        className={styles["icon-size"]} />
                                </TableCell>
                                <TableCell size="large">COMPLETE DISABLEMENT</TableCell>
                                <TableCell size="large">$200,000</TableCell>
                                <TableCell size="large">
                                    <ul>
                                        <li>Complete Disablement Cover - accelerated</li>
                                        <li>Complete Disablement Cover - standalone</li>
                                    </ul>
                                </TableCell>
                            </TableRow>
                            {/* Monthly Disability */}
                            <TableRow>
                                <TableCell size="large" alignContent="center">
                                    <Icon
                                        id="SliderMinus"
                                        className={styles["icon-size"]} />
                                </TableCell>
                                <TableCell size="large">MONTHLY DISABILITY</TableCell>
                                <TableCell size="large">$2,000 per month</TableCell>
                                <TableCell size="large">
                                    <ul>
                                        <li>Income Cover - Agreed Value</li>
                                        <li>Income Cover – Indemnity</li>
                                        <li>Income Cover - Loss of Earnings</li>
                                        <li>Income Cover - Loss of Earnings Ultra</li>
                                        <li>Mortgage Repayment Cover</li>
                                        <li>Monthly Disability**</li>
                                        <li>Start-Up Monthly Disability</li>
                                    </ul>
                                </TableCell>
                            </TableRow>
                        </TableSection>
                        <p className="text-disclaimer text-font-size-xs">*Minimum sum insured requirement for Life Income Cover</p>
                        <p className="text-disclaimer text-font-size-xs">**For Assurance Extra Business Monthly Disability variable cover, we use the aggregate sum insured for all months of cover selected.</p>
                    </TableContainer>
                    <p>
                        <a
                            target="_blank"
                            rel="noopener"
                            href="https://www.chubb.com/nz-en/multi-benefit-discount.html">
                            Read more
                        </a>
                        {" on Chubb Life's website."}
                    </p>
                </div>
            )}
        </LModal>
    );
};

export default ChubbLifeMultiBenefitDiscountModal;
